import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=6ba7219d&scoped=true&lang=pug&"
import script from "./ReferralCard.vue?vue&type=script&lang=js&"
export * from "./ReferralCard.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCard.vue?vue&type=style&index=0&id=6ba7219d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7219d",
  null
  
)

export default component.exports